import Tooltip from "@mui/material/Tooltip";
import { tooltipClasses } from "@mui/material/Tooltip";
import React from "react";

interface DynamicTooltipProps {
  title: string;
  children: React.ReactNode;
}

const DynamicToolTip: React.FC<DynamicTooltipProps> = ({
  title,
  children,
}) => {
  const slotProps = {
    popper: {
      sx: {
        [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
          {
            marginTop: "8px",
          },
      },
    },
  };

  return (
    <Tooltip title={title} slotProps={slotProps}>
      {React.isValidElement(children) ? children : <span>{children}</span>}
    </Tooltip>
  );
};

export default DynamicToolTip;
